import type { FC } from 'react'
import { Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

/**
 * A card with no fields says so. A row of "-" against "-" reads as a field
 * whose value is missing, not as a card the Gateway returned nothing for.
 */
const EmptyCardMessage: FC<{ message: string }> = ({ message }) => {
  const { mode } = useAppTheme()

  return (
    <Typography
      sx={{
        fontFamily:
          '"Rubik", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        fontSize: 14,
        fontWeight: 300,
        py: 2,
        textAlign: 'center',
        color: mode === 'dark' ? '#9CA3AF' : '#6B7280',
      }}
    >
      {message}
    </Typography>
  )
}

export default EmptyCardMessage
